import { Box, PageTitle, Text, Button, Spacer } from "@flexisaf/flexibull2";
import { RiFeedbackLine } from "react-icons/ri";
import Theme from "../../theme";
import { useSelector } from "react-redux";
import { currentFeedback } from "../../redux/feedback/selectors";
import styled from "styled-components";
import QuestionEditor from "../../components/questions/modals/questionEditor";
import { useState } from "react";
import useFeedbackGet from "../../hooks/feedback/useFeedbackGet";

const Feedback = () => {
  const currentFeed = useSelector(currentFeedback);
  const [modal, setModal] = useState({ data: null, show: false });
  const { isPosting } = useSelector((state) => state.feedback);

  const { refetch, postFeedback } = useFeedbackGet({
    questionId: "",
    resolved: false,
    issueType: "",
  });
  return (
    <>
      <PageTitle>
        <RiFeedbackLine size={25} style={{ position: "absolute" }} />

        <Text bold size={Theme.H3} style={{ padding: "10px 35px" }}>
          User Feedback
        </Text>
      </PageTitle>

      <Wrapper>
        <Container>
          <Box display="flex" className="header">
            <Box pad="0px">
              <h2>{currentFeed?.question?.topic}</h2>
            </Box>
          </Box>
          <Box pad="10px 30px 20px 30px">
            <Box>
              <Box className="user_choice">
                <Text color={Theme.PrimaryGrey}>
                  There is an issue with the{" "}
                  {currentFeed?.issues?.map((issue) => (
                    <Text>{issue?.type.toLowerCase()}</Text>
                  ))}
                </Text>
              </Box>
              <Box pad="20px 0px">
                <Text size="20px" block style={{ fontWeight: 300 }}>
                  {currentFeed?.message === ""
                    ? "No message"
                    : currentFeed?.message}
                </Text>
              </Box>
              <Box display="flex" style={{ justifyContent: "space-between" }}>
                <Box>
                  <h3 style={{ fontWeight: 500 }}>User Details</h3>
                  <Text block size={Theme.H3} style={{ padding: "10px 0" }}>
                    <i className="saf-user" /> {currentFeed?.id}
                  </Text>
                  <Text block>
                    {" "}
                    <i className="saf-message" /> {currentFeed?.createdBy}
                  </Text>
                </Box>
              </Box>
            </Box>
          </Box>
          <Spacer space={25} />
          <Box>
            <Button
              style={{ float: "left", width: "100px" }}
              onClick={() => {
                let payload = {
                  data: { id: currentFeed.id, resolved: true },
                  callback: () => {
                    refetch();
                  },
                };
                postFeedback(payload);
              }}
              progress={isPosting}
            >
              Resolved
            </Button>
            <Button
              style={{ float: "right", width: "100px" }}
              onClick={() => {
                setModal({ show: true, data: currentFeed?.question });
              }}
            >
              View
            </Button>
          </Box>
        </Container>
      </Wrapper>
      <QuestionEditor
        open={modal.show}
        closeModal={() => {
          setModal({
            show: false,
            data: null,
          });
        }}
        data={modal.data}
        currentPaper={currentFeed?.question?.paper}
        refetch={refetch}
      />
    </>
  );
};

export default Feedback;

const Wrapper = styled.div``;
const Container = styled.div`
  width: 80%;

  .header {
    justify-content: space-between;
    border-bottom: 1px solid grey;
  }
  .user_choice {
    font-size: 20px;
    border-left: 3px solid #187a97;
    color: #424242;
    padding: 0.35rem;
    font-weight: 300;
  }
  .btnCancel {
    width: 40%;
    border: 2px solid grey;
    border-radius: 0;
    height: 50px;
  }
  .nextButton {
    width: 40%;
    border-radius: 0;
    height: 50px;
  }
  .flexDiv {
    display: flex;
    align-items: center;
    justify-content: space-around;
    h2 {
      font-weight: 600;
      font-size: medium;
    }
    div {
      width: 100%;
    }
  }
`